"use client";

import { useEffect } from "react";

/** Loads Toastify CSS after hydration so it is not render-blocking. */
export function LoadDeferredToastifyStyles() {
  useEffect(() => {
    void import("react-toastify/dist/ReactToastify.css");
  }, []);
  return null;
}
